var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6406 8.45963C11.8728 7.85089 12 7.1903 12 6.5C12 3.46244 9.53759 1 6.5 1C3.46244 1 1 3.46244 1 6.5C1 9.53759 3.46244 12 6.5 12C7.04955 12 7.58027 11.9194 8.08099 11.7694",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3V6",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L6 6",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#FA7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndtime);
export default __webpack_public_path__ + "static/media/End time.fc87e204786a25b8d5bfecbcf14adb7a.svg";
export { ForwardRef as ReactComponent };